<template>
    <v-app>
        <v-system-bar style="padding: 0; margin: 0" app absolute>
            <v-img
                position="top"
                height="20px"
                width="100%"
                :src="$page.props.statics.background"
            ></v-img>
        </v-system-bar>
        <v-app-bar height="78px" color="white" absolute app>
            <template v-slot:extension v-if="!$vuetify.breakpoint.mobile">
                <v-container>
                    <div style="margin-right: -52px; margin-left: -52px">
                        <v-tabs
                            v-model="selectedPage"
                            optional
                            centered
                            background-color="transparent"
                        >
                            <v-tab
                                link
                                @click="$inertia.get('/')"
                                value="/"
                                key="/"
                                class=""
                                >Home
                            </v-tab>

                            <v-tab
                                v-for="item in departments"
                                :key="item.id"
                                link
                                @click="
                                    $inertia.get(
                                        route('catalogue.department', item.slug)
                                    )
                                "
                                v-text="item.name"
                                :value="item.name"
                                class=""
                            />
                        </v-tabs>
                    </div>
                </v-container>
            </template>

            <v-container class="d-flex">
                <inertia-link class="py-1" href="/">
                    <v-img
                        max-height="70px"
                        max-width="180px"
                        contain
                        position="left"
                        :src="$page.props.statics.logo"
                    />
                </inertia-link>

                <socials
                    v-if="!$vuetify.breakpoint.mobile"
                    class="ml-auto my-auto"
                />

                <v-app-bar-nav-icon
                    v-if="$vuetify.breakpoint.mobile"
                    class="ml-auto"
                    @click="drawer = !drawer"
                />
            </v-container>
        </v-app-bar>

        <v-navigation-drawer app temporary right v-model="drawer">
            <v-list>
                <v-list-item link @click="$inertia.get('/')">
                    <v-list-item-title v-text="'Home'" />
                </v-list-item>

                <v-list-item
                    v-for="item in departments"
                    link
                    @click="
                        $inertia.get(route('catalogue.department', item.slug))
                    "
                    :key="item.id"
                >
                    <v-list-item-title v-text="item.name" />
                </v-list-item>

                <v-list-item :href="`//${$page.props.company_info.website}`">
                    <v-icon small class="mr-1">mdi-arrow-left</v-icon>
                    Back to KINGSR.COM
                    <v-img
                        class="ml-1 mb-1"
                        max-width="20px"
                        contain
                        :src="$page.props.statics.footer_image"
                    />
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <v-main class="mb-8">
            <v-container class="mt-4">
                <slot />
            </v-container>
        </v-main>

        <v-footer app absolute elevation="10">
            <v-container class="py-8">
                <v-row>
                    <v-col cols="12" md="4">
                        <div>
                            King Sound Reinforcement <br />
                            Unit 22/24 Barton Hill Trading Estate <br />
                            Maze street <br />
                            Bristol <br />
                            BS5 9RD
                        </div>
                    </v-col>

                    <v-col
                        cols="12"
                        md="4"
                        class="d-flex flex-column align-center"
                    >
                        <v-img
                            width="100"
                            height="50"
                            contain
                            :src="$page.props.statics.footer_image"
                        />

                        <v-btn
                            v-if="!$vuetify.breakpoint.mobile"
                            class="my-8"
                            small
                            :href="`//${$page.props.company_info.website}`"
                        >
                            <v-icon small class="mr-1">mdi-arrow-left</v-icon>
                            Back to KINGSR.COM
                        </v-btn>

                        <socials />
                    </v-col>

                    <v-col cols="12" md="4">
                        <company-contact-info
                            class="d-flex flex-column align-end"
                        />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <div class="text-subtitle-2 text-center">
                            Copyright 1995-{{ new Date().getFullYear() }} &copy;
                            King Sound Reinforcement Ltd. All Rights Reserved.
                            <a
                                target="_blank"
                                :href="$page.props.company_info.privacy_policy"
                                >Privacy and Cookie Policy</a
                            >
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-footer>
        <cookie-popup />
    </v-app>
</template>

<script>
import Socials from "@/Components/Catalogue/Socials";
import CompanyContactInfo from "@/Components/Catalogue/CompanyContactInfo";
import CookiePopup from "../Components/Shared/CookiePopup";

export default {
    name: "AppLayout",
    components: {
        CookiePopup,
        CompanyContactInfo,
        Socials,
    },
    data() {
        return {
            drawer: false,
            departments: this.$page.props.departments,
        };
    },

    mounted() {
        // Close the mobile nav on navigate
        this.$once(
            "hook:destroyed",
            this.$inertia.on("navigate", () => {
                this.drawer = false;
            })
        );
    },

    computed: {
        selectedPage: {
            get() {
                if (this.$page.url === "/") {
                    return 0;
                }

                const index = this.departments.findIndex((dep) => {
                    return (
                        this.$page.url ===
                            `catalogue/${this.route(
                                "catalogue.department",
                                dep.slug
                            )}` ||
                        this.$page.url.includes(
                            `catalogue/${this.route(
                                "catalogue.department",
                                dep.slug
                            )}/`
                        )
                    );
                });

                if (index !== -1) {
                    return index + 1;
                }

                return null;
            },

            set() {},
        },
    },
};
</script>

<style lang="scss">
.v-tabs {
    .v-tab {
        min-width: initial;
        padding: 0 8px;
    }
}
</style>
